import ProfileShareContainer from '../../containers/profile/ProfileShareContainer'

const ProfileSharePage = () => {
  return <ProfileShareContainer />
}

export default ProfileSharePage
